import state from './state'
import mutations from "@/store/mutations"
import actions from './actions'
import getters from './getters'

const scooter = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
export default scooter